import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Star, 
  Users, 
  TrendingUp, 
  Award, 
  CheckCircle, 
  ArrowRight,
  Quote,
  Building2,
  Globe,
  Clock,
  DollarSign,
  Target,
  BarChart3,
  Play,
  Download,
  Share2,
  Heart,
  MessageSquare,
  Calendar,
  MapPin,
  Briefcase,
  Zap,
  Lightbulb,
  Shield,
  Settings
} from 'lucide-react';

const SuccessStoriesPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Stories' },
    { id: 'job-seekers', name: 'Job Seekers' },
    { id: 'employers', name: 'Employers' },
    { id: 'enterprise', name: 'Enterprise' },
    { id: 'contractors', name: 'Contractors' }
  ];

  const successStories = [
    {
      id: 1,
      category: 'job-seekers',
      name: 'Sarah Johnson',
      role: 'Chief Nursing Officer',
      company: 'Major Hospital Network',
      // location: '',
      image: '/api/placeholder/150/150',
      rating: 5,
      quote: "TechMind transformed our approach to healthcare staffing. Their understanding of our specialized needs and ability to find qualified candidates quickly has been invaluable to our operations.",
      // story: "After being laid off during the pandemic, I was struggling to find opportunities that matched my skills and career goals. TechMind's AI-powered job matching connected me with the perfect role at TechCorp, and their career coaching helped me ace the interview process.",
      // metrics: {
      //   timeToHire: '3 weeks',
      //   salaryIncrease: '25%',
      //   jobSatisfaction: '9.5/10'
      // },
      // tags: ['Software Development', 'Career Transition', 'Remote Work']
    },
    {
      id: 2,
      category: 'employers',
      name: 'Michael Chen',
      role: 'CTO',
      company: 'Leading Financial Services Firm',
      location: 'Austin, TX',
      image: '/api/placeholder/150/150',
      rating: 5,
      quote: "TechMind didn't just fill positions—they understood our business challenges and found talent that could truly drive our digital transformation forward.",
      // story: "As a growing tech company, we were struggling with long hiring cycles and inconsistent candidate quality. TechMind's comprehensive recruitment solution streamlined our entire process, from sourcing to onboarding.",
      // metrics: {
      //   timeToHire: 'Reduced by 50%',
      //   candidateQuality: 'Improved by 40%',
      //   costSavings: '$150K annually'
      // },
      // tags: ['Tech Recruitment', 'Process Optimization', 'Cost Reduction']
    },
    {
      id: 3,
      category: 'enterprise',
      name: 'Alex Rivera',
      role: 'Founder & CEO',
      company: 'Innovative SaaS Startup',
      location: 'New York, NY',
      image: '/api/placeholder/150/150',
      rating: 5,
      quote: "As a fast-growing startup, finding the right talent quickly was make-or-break for us. TechMind understood our culture and technical needs perfectly, delivering exceptional candidates who have become core team members.",
      // story: "Our company was experiencing rapid growth and needed to scale our hiring operations quickly. TechMind's enterprise recruitment platform provided the scalability and automation we needed to meet our aggressive hiring targets.",
      metrics: {
        hiringScale: '300% increase',
        costReduction: '40% savings',
        timeToMarket: '60% faster'
      },
      tags: ['Enterprise Scaling', 'Automation', 'Global Hiring']
    },
    // {
    //   id: 4,
    //   category: 'contractors',
    //   name: 'Alex Thompson',
    //   role: 'Senior Developer',
    //   company: 'Freelance',
    //   location: 'Remote',
    //   image: '/api/placeholder/150/150',
    //   rating: 5,
    //   quote: "TechMind helped me find high-paying contract work that fits my lifestyle perfectly.",
    //   story: "As a contractor, I was tired of inconsistent work and low-paying gigs. TechMind connected me with premium contract opportunities that pay well and offer the flexibility I need.",
    //   metrics: {
    //     rateIncrease: '60% higher rates',
    //     workConsistency: '95% uptime',
    //     clientSatisfaction: '4.9/5'
    //   },
    //   tags: ['Contract Work', 'Rate Optimization', 'Work-Life Balance']
    // },
    // {
    //   id: 5,
    //   category: 'job-seekers',
    //   name: 'Emily Rodriguez',
    //   role: 'UX Designer',
    //   company: 'Design Studio',
    //   location: 'Los Angeles, CA',
    //   image: '/api/placeholder/150/150',
    //   rating: 5,
    //   quote: "I love how TechMind matches me with relevant opportunities. It saved me so much time!",
    //   story: "The job search process was overwhelming until I found TechMind. Their smart matching technology and personalized recommendations made finding the right opportunities effortless.",
    //   metrics: {
    //     applicationsSubmitted: 'Reduced by 70%',
    //     interviewRate: 'Increased by 80%',
    //     timeToOffer: '4 weeks'
    //   },
    //   tags: ['UX Design', 'Smart Matching', 'Efficiency']
    // },
    // {
    //   id: 6,
    //   category: 'employers',
    //   name: 'David Wilson',
    //   role: 'CEO',
    //   company: 'StartupXYZ',
    //   location: 'Seattle, WA',
    //   image: '/api/placeholder/150/150',
    //   rating: 5,
    //   quote: "Their contract staffing service was perfect for our project-based needs. Highly recommended!",
    //   story: "As a startup, we needed flexible staffing solutions for our project-based work. TechMind's contract staffing service provided us with skilled professionals exactly when we needed them.",
    //   metrics: {
    //     projectCompletion: '100% on time',
    //     costSavings: '35% vs full-time',
    //     teamSatisfaction: '4.8/5'
    //   },
    //   tags: ['Startup', 'Contract Staffing', 'Project Management']
    // }
  ];

  const filteredStories = activeCategory === 'all' 
    ? successStories 
    : successStories.filter(story => story.category === activeCategory);

  const stats = [
    {
      icon: <Users className="w-8 h-8 text-blue-600" />,
      number: '50,000+',
      label: 'Client Satisfaction'
    },
    {
      icon: <TrendingUp className="w-8 h-8 text-green-600" />,
      number: '98%',
      label: 'Client Satisfaction'
    },
    {
      icon: <Clock className="w-8 h-8 text-purple-600" />,
      number: '60%',
      label: 'Faster Hiring'
    },
    {
      icon: <DollarSign className="w-8 h-8 text-orange-600" />,
      number: '$2M+',
      label: 'Cost Savings'
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-[#1A193B] pt-20 text-white">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-3 lg:px-4 py-24 lg:py-32">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              Success Stories
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-purple-100">
              {/* Real stories from job seekers, employers, and companies who found success with TechMind */}
              Real results from our industry-specific talent solutions
            </p>
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      {/* <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Impact by the Numbers
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              See the real impact TechMind has made for our clients and candidates
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
                className="text-center p-6 rounded-lg hover:shadow-lg transition-shadow"
              >
                <div className="flex justify-center mb-4">
                  {stat.icon}
                </div>
                <div className="text-3xl font-bold text-gray-900 mb-2">
                  {stat.number}
                </div>
                <p className="text-gray-600 font-medium">
                  {stat.label}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Category Filter */}
      {/* <section className="py-8 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-6 py-3 rounded-full font-medium transition-colors ${
                  activeCategory === category.id
                    ? 'bg-purple-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section> */}

      {/* Success Stories Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {filteredStories.map((story, index) => (
              <motion.div
                key={story.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow"
              >
                {/* Header */}
                <div className="flex items-start justify-between mb-6">
                  <div className="flex items-center">
                    <div className="w-16 h-16 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full flex items-center justify-center text-white font-bold text-xl mr-4">
                      {story.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900">{story.name}</h3>
                      <p className="text-gray-600">{story.role}</p>
                      <p className="text-sm text-gray-500">{story.company}</p>
                    </div>
                  </div>
                  {/* <div className="flex items-center">
                    {[...Array(story.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                    ))}
                  </div> */}
                </div>

                {/* Quote */}
                <div className="mb-6">
                  <Quote className="w-8 h-8 text-purple-400 mb-3" />
                  <blockquote className="text-lg text-gray-700 italic">
                    "{story.quote}"
                  </blockquote>
                </div>

                {/* Story */}
                <p className="text-gray-600 mb-6">
                  {story.story}
                </p>

                {/* Metrics */}
                {/* <div className="grid grid-cols-3 gap-4 mb-6">
                  {Object.entries(story.metrics).map(([key, value]) => (
                    <div key={key} className="text-center">
                      <div className="text-lg font-semibold text-purple-600">{value}</div>
                      <div className="text-sm text-gray-500 capitalize">
                        {key.replace(/([A-Z])/g, ' $1').trim()}
                      </div>
                    </div>
                  ))}
                </div> */}

                {/* Tags */}
                {/* <div className="flex flex-wrap gap-2 mb-6">
                  {story.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className="px-3 py-1 bg-purple-100 text-purple-700 text-sm rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div> */}

                {/* Location */}
                {/* <div className="flex items-center text-sm text-gray-500">
                  <MapPin className="w-4 h-4 mr-1" />
                  {story.location}
                </div> */}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Case Study */}
      {/* <section className="py-16 bg-gradient-to-r from-purple-600 to-pink-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4">
              Featured Case Study: Global Tech Expansion
            </h2>
            <p className="text-xl text-purple-100 max-w-3xl mx-auto">
              How TechMind helped a Fortune 500 company scale their global hiring operations
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-semibold mb-4">The Challenge</h3>
              <p className="text-purple-100 mb-6">
                A leading technology company needed to hire 500+ engineers across 15 countries within 6 months to support their global expansion.
              </p>
              
              <h3 className="text-2xl font-semibold mb-4">The Solution</h3>
              <p className="text-purple-100 mb-6">
                TechMind implemented a comprehensive global recruitment platform with AI-powered candidate matching, automated screening, and multi-language support.
              </p>
              
              <h3 className="text-2xl font-semibold mb-4">The Results</h3>
              <ul className="space-y-2 text-purple-100">
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 mr-2" />
                  500+ engineers hired in 5 months
                </li>
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 mr-2" />
                  60% reduction in time-to-hire
                </li>
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 mr-2" />
                  $2M in cost savings
                </li>
                <li className="flex items-center">
                  <CheckCircle className="w-5 h-5 mr-2" />
                  95% candidate satisfaction rate
                </li>
              </ul>
            </div>
            
            <div className="bg-white/10 rounded-lg p-8">
              <div className="text-center">
                <Play className="w-16 h-16 mx-auto mb-4 text-purple-200" />
                <h4 className="text-xl font-semibold mb-2">Watch the Full Case Study</h4>
                <p className="text-purple-100 mb-6">
                  Learn how TechMind transformed global hiring for this Fortune 500 company
                </p>
                <button className="px-6 py-3 bg-white text-purple-600 rounded-md hover:bg-gray-100 transition-colors font-medium">
                  Watch Video
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Ready to Write Your Success Story?
            </h2>
            <p className="text-xl mb-8 text-gray-600 max-w-3xl mx-auto">
            Let's discuss how our talent solutions can help your organization achieve its goals.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {/* <Link 
                to="/register"
                className="px-8 py-3 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors font-medium"
              >
                Get Started Today
              </Link> */}
              <Link 
                to="/contact"
                className="px-8 py-3 border border-purple-600 text-purple-600 rounded-md hover:bg-purple-50 transition-colors font-medium"
              >
                Contact Us Today
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default SuccessStoriesPage; 